import { fork } from "redux-saga/effects";
import watchStrength from "./strength/saga";
import watchSlump from "./slump/saga";
import watchDistance from "./distance/saga";
import watchStructure from "./structure/saga";
import watchProductType from "./product-type/saga";
import watchPricelist from "./pricelist/saga";
import watchVehicleTypeConfig from "./vehicletype-config/saga";
import watchProducts from "./product/saga";
import watchPlantProduct from "./plant-product/saga";

const watchProductMangement = [
  fork(watchStrength),
  fork(watchSlump),
  fork(watchDistance),
  fork(watchStructure),
  fork(watchProductType),
  fork(watchPricelist),
  fork(watchVehicleTypeConfig),
  fork(watchProducts),
  fork(watchPlantProduct),
];

export default watchProductMangement;
